import './AppFooter.scss';

const AppFooter = () => {
    return (
        <footer className="wallet-footer">
            <div className="wallet-footer__inner">
                <div className="wallet-footer__left">
                    <span className="wallet-footer__brand">Capital</span>
                    <span className="wallet-footer__sep">•</span>
                    <span className="wallet-footer__copy">© {new Date().getFullYear()}</span>
                </div>

                <div className="wallet-footer__right">
                    <a
                        className="wallet-footer__link"
                        href="https://andrejk.dev"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        andrejk.dev
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default AppFooter;